import { ApisauceInstance } from 'apisauce';

// Url
import { url } from '../api.url';

// Type
type formDataPostPayment = {
	merchantRefId: string
};

const payments = (api: ApisauceInstance) => {
	const paymentsHostedPage = (formData: formDataPostPayment) => api.post(url.payments, formData || {});

	return {
		paymentsHostedPage
	};
};

export default payments;
